import router from '@/router'
import InvoiceService from '@/services/InvoiceService.js'

export const namespaced = true

export const state = {
  paymentTerms: [],
  isFetchingPaymentTerms: false,
  isCreatingInvoice: false,
  invoiceDraftId: null,
  shouldCheckOut: false,
  dialog: {
    show: false,
    isLoading: false,
    invoiceId: null, // Sätts innan invoice hämtats, för att säkerställa att rätt request skriver över data i dialogen
    invoice: null,
    openTab: null
  },
  isLoadingRegisterPayment: false,
  isLoadingTerminalPayment: false,
  isLoadingReverseApplicationIds: [],
  isLoadingReversePaymentIds: [],
  isLoadingPayment: false,
  isLoadingRegisterCreditInvoiceIds: [], // faktura id för vilka kreditfakturor håller på att skapas
  isLoadingConvertToCredit: false,
  isSendingInvoiceIds: [],
  isSendingReminderInvoiceIds: [],
  isSendingConfirmationPaymentIds: [],
  isAwaitingEmailSavedInvoiceIds: [],
  isAwaitingEmailSavedPaymentIds: [],
  isLoadingRefundPaymentIds: [],

  triggerInvoiceUpdated: 0,
  triggerPaymentApplicationUpdated: 0,
  triggerPaymentUpdated: 0,
  triggerCustomerCreditUpdated: 0,
  triggerRetryPayment: 0
}

export const mutations = {
  SET_PAYMENT_TERMS (state, val) {
    state.paymentTerms = val
  },
  SET_IS_FETCHING_PAYMENT_TERMS (state, val) {
    state.isFetchingPaymentTerms = val
  },
  SET_IS_CREATING_INVOICE (state, val) {
    state.isCreatingInvoice = val
  },
  SET_AWAITING_INVOICE_DRAFT_ID (state, val) {
    state.invoiceDraftId = val
  },
  SET_SHOULD_CHECK_OUT (state, val) {
    state.shouldCheckOut = val
  },
  SET_SHOW_DIALOG (state, val) {
    state.dialog.show = val
  },
  SET_DIALOG_IS_LOADING (state, val) {
    state.dialog.isLoading = val
  },
  SET_DIALOG_FETCHING_CHUNKS (state, payload) {
    if (payload.isFetching) {
      const i = state.dialog.fetchingChunks.findIndex(id => id === payload.chunkName)
      if (i < 0) {
        state.dialog.fetchingChunks.push(payload.chunkName)
      }
    } else {
      const i = state.dialog.fetchingChunks.findIndex(id => id === payload.chunkName)
      state.dialog.fetchingChunks.splice(i, 1)
    }
  },
  SET_DIALOG_INVOICE (state, val) {
    state.dialog.invoice = val
  },
  SET_DIALOG_INVOICE_ID (state, val) {
    state.dialog.invoiceId = val
  },
  SET_DIALOG_OPEN_TAB (state, val) {
    state.dialog.openTab = val
  },
  ADD_DIALOG_INVOICE_EMAIL (state, val) {
    const index = state.dialog.invoice.emails.findIndex(email => {
      return email.id === val.id
    })
    if (index >= 0) {
      state.dialog.invoice.emails.splice(index, 1, val)
    } else {
      state.dialog.invoice.emails.push(val)
    }
  },
  SET_IS_LOADING_REGISTER_PAYMENT (state, val) {
    state.isLoadingRegisterPayment = val
  },
  SET_IS_LOADING_TERMINAL_PAYMENT (state, val) {
    state.isLoadingTerminalPayment = val
  },
  SET_IS_LOADING_CONVERT_TO_CREDIT (state, val) {
    state.isLoadingConvertToCredit = val
  },
  SET_IS_LOADING_REVERSE_PAYMENT_APPLICATION_IDS (state, payload) {
    if (payload.val) {
      const i = state.isLoadingReverseApplicationIds.findIndex(id => id === payload.paymentApplicationId)
      if (i < 0) {
        state.isLoadingReverseApplicationIds.push(payload.paymentApplicationId)
      }
    } else {
      const i = state.isLoadingReverseApplicationIds.findIndex(id => id === payload.paymentApplicationId)
      state.isLoadingReverseApplicationIds.splice(i, 1)
    }
  },
  SET_IS_LOADING_REVERSE_PAYMENT_IDS (state, payload) {
    if (payload.val) {
      const i = state.isLoadingReversePaymentIds.findIndex(id => id === payload.paymentId)
      if (i < 0) {
        state.isLoadingReversePaymentIds.push(payload.paymentId)
      }
    } else {
      const i = state.isLoadingReversePaymentIds.findIndex(id => id === payload.paymentId)
      state.isLoadingReversePaymentIds.splice(i, 1)
    }
  },
  SET_IS_LOADING_REGISTER_CREDIT_INVOICE_IDS (state, payload) {
    if (payload.val) {
      const i = state.isLoadingRegisterCreditInvoiceIds.findIndex(id => id === payload.originalInvoiceId)
      if (i < 0) {
        state.isLoadingRegisterCreditInvoiceIds.push(payload.originalInvoiceId)
      }
    } else {
      const i = state.isLoadingRegisterCreditInvoiceIds.findIndex(id => id === payload.originalInvoiceId)
      state.isLoadingRegisterCreditInvoiceIds.splice(i, 1)
    }
  },
  SET_IS_LOADING_PAYMENT (state, val) {
    state.isLoadingPayment = val
  },
  TRIGGER_RETRY_PAYMENT (state, val) {
    state.triggerRetryPayment++
  },
  SET_IS_SENDING_INVOICE_IDS (state, payload) {
    if (payload.val) {
      const i = state.isSendingInvoiceIds.findIndex(id => id === payload.invoiceId)
      if (i < 0) {
        state.isSendingInvoiceIds.push(payload.invoiceId)
      }
    } else {
      const i = state.isSendingInvoiceIds.findIndex(id => id === payload.invoiceId)
      state.isSendingInvoiceIds.splice(i, 1)
    }
  },
  SET_IS_SENDING_REMINDER_INVOICE_IDS (state, payload) {
    if (payload.val) {
      const i = state.isSendingReminderInvoiceIds.findIndex(id => id === payload.invoiceId)
      if (i < 0) {
        state.isSendingReminderInvoiceIds.push(payload.invoiceId)
      }
    } else {
      const i = state.isSendingReminderInvoiceIds.findIndex(id => id === payload.invoiceId)
      state.isSendingReminderInvoiceIds.splice(i, 1)
    }
  },
  SET_IS_SENDING_CONFIRMATION_PAYMENT_IDS (state, payload) {
    if (payload.val) {
      const i = state.isSendingConfirmationPaymentIds.findIndex(id => id === payload.paymentId)
      if (i < 0) {
        state.isSendingConfirmationPaymentIds.push(payload.paymentId)
      }
    } else {
      const i = state.isSendingConfirmationPaymentIds.findIndex(id => id === payload.paymentId)
      state.isSendingConfirmationPaymentIds.splice(i, 1)
    }
  },
  SET_IS_AWAITING_EMAIL_SAVED_INVOICE_ID (state, payload) {
    if (payload.val) {
      const i = state.isAwaitingEmailSavedInvoiceIds.findIndex(id => id === payload.invoiceId)
      if (i < 0) {
        state.isAwaitingEmailSavedInvoiceIds.push(payload.invoiceId)
      }
    } else {
      const i = state.isAwaitingEmailSavedInvoiceIds.findIndex(id => id === payload.invoiceId)
      state.isAwaitingEmailSavedInvoiceIds.splice(i, 1)
    }
  },
  SET_IS_AWAITING_EMAIL_SAVED_PAYMENT_ID (state, payload) {
    if (payload.val) {
      const i = state.isAwaitingEmailSavedPaymentIds.findIndex(id => id === payload.paymentId)
      if (i < 0) {
        state.isAwaitingEmailSavedPaymentIds.push(payload.paymentId)
      }
    } else {
      const i = state.isAwaitingEmailSavedPaymentIds.findIndex(id => id === payload.paymentId)
      state.isAwaitingEmailSavedPaymentIds.splice(i, 1)
    }
  },
  SET_IS_LOADING_REFUND_PAYMENT_IDS (state, payload) {
    if (payload.val) {
      const i = state.isLoadingRefundPaymentIds.findIndex(id => id === payload.paymentId)
      if (i < 0) {
        state.isLoadingRefundPaymentIds.push(payload.paymentId)
      }
    } else {
      const i = state.isLoadingRefundPaymentIds.findIndex(id => id === payload.paymentId)
      state.isLoadingRefundPaymentIds.splice(i, 1)
    }
  },
  TRIGGER_INVOICE_UPDATED (state) {
    state.triggerInvoiceUpdated++
  },
  TRIGGER_PAYMENT_APPLICATION_UPDATED (state) {
    state.triggerPaymentApplicationUpdated++
  },
  TRIGGER_PAYMENT_UPDATED (state) {
    state.triggerPaymentUpdated++
  },
  TRIGGER_CUSTOMER_CREDIT_UPDATED (state) {
    state.triggerCustomerCreditUpdated++
  }
}

export const actions = {
  fetchPaymentTerms ({ commit }) {
    commit('SET_IS_FETCHING_PAYMENT_TERMS', true)
    return InvoiceService.getPaymentTerms()
      .then(({ data }) => {
        window.enrich.enrichPaymentTerm(data.data.payment_terms)
        commit('SET_PAYMENT_TERMS', data.data.payment_terms)
        commit('SET_IS_FETCHING_PAYMENT_TERMS', false)
      })
  },
  openDialogById ({ state, commit }, { invoiceId, startTab }) {
    commit('SET_DIALOG_INVOICE_ID', invoiceId) // dialog.invoiceId garanterar att vi inte skriver över data i invoice dialog med data tillhörande en annan invoice
    commit('SET_DIALOG_INVOICE', null)
    commit('SET_DIALOG_OPEN_TAB', startTab || null)
    commit('SET_DIALOG_IS_LOADING', true)
    commit('SET_SHOW_DIALOG', true)

    return InvoiceService.getInvoice(invoiceId)
      .then(({ data }) => {
        if (data.status === 'success' && invoiceId === state.dialog.invoiceId) {
          window.enrich.enrichInvoice(data.data.invoice)
          commit('SET_DIALOG_INVOICE', data.data.invoice)
        }
      })
      .finally(() => {
        if (invoiceId === state.dialog.invoiceId || !state.dialog.show) {
          commit('SET_DIALOG_IS_LOADING', false)
        }
      })
  },
  async createInvoice ({ commit, dispatch }, { customer, booking, displayedPayableAmount, bookingGroup, paymentTerm, invoiceMessage, orderReference, dueDate, charges, customerCreditAmount, accommodationChargesAmount = 0, isCashInvoice = false, paymentMethod, shouldCheckOut = false, shouldSendEmail = true, selectedPaymentOption = 'ALL' }) {
    commit('SET_IS_CREATING_INVOICE', true)
    const bookingId = booking ? booking.id : null
    const bookingGroupId = bookingGroup ? bookingGroup.id : null

    if (isCashInvoice) {
      commit('posCheckout/SET_IS_LOADING_PAYMENT', true, { root: true })
      if (paymentMethod && paymentMethod.gateway === 'integrated_terminal') {
        dispatch('posTerminal/resetStatusDialog', null, { root: true })
        commit('posTerminal/SET_TERMINAL_CANCELLING', false, { root: true })
        commit('SET_IS_LOADING_TERMINAL_PAYMENT', true)
      }
    }
    return InvoiceService.createInvoice({ customer, bookingId, displayedPayableAmount, bookingGroupId, paymentTerm, invoiceMessage, orderReference, dueDate, charges, customerCreditAmount, accommodationChargesAmount, isCashInvoice, paymentMethod, shouldCheckOut, shouldSendEmail, selectedPaymentOption })
      .then(({ data }) => {
        let awaitConfirmation = false
        if (data.status === 'success') {
          if (data.data.booking) {
            const booking = data.data.booking
            window.enrich.enrichBooking(booking)
            commit('booking/ADD_BOOKING', booking, { root: true })
          }
          if (data.data.transaction_status === 'await_confirmation') {
            console.log('await_confirmation')
            awaitConfirmation = true
            commit('SET_AWAITING_INVOICE_DRAFT_ID', data.data.invoice_draft_id)
            commit('SET_SHOULD_CHECK_OUT', shouldCheckOut)
            dispatch('posTerminal/startTerminalTimeout', {
              timeout: data.data.terminal_timeout,
              invoiceDraftId: data.data.invoice_draft_id
            }, { root: true })
          } else {
            console.log('confirmed')
            if (router.history.current.name === 'PosRegister') {
              // resettar varukorgen och kunden i kassan om fakturerat från kassan
              dispatch('posCart/reset', null, { root: true })
              commit('posRegister/SET_CUSTOMER', null, { root: true })
            }
            // öppnar customer eller booking dialog med faktura-tabben öppen
            if (shouldCheckOut) {
              router.push({ name: 'ActionsItems' })
            } else if (data.data.booking_id) {
              dispatch('booking/openDialogById', { bookingId: data.data.booking_id, startTab: 'invoices' }, { root: true })
            } else if (data.data.booking_group_id) {
              dispatch('bookingGroup/openDialogById', { bookingGroupId: data.data.booking_group_id, startTab: 'invoices' }, { root: true })
            } else {
              dispatch('customer/openDialogById', { customerId: data.data.customer_id, startTab: 'invoices' }, { root: true })
            }
          }
        }
        if (!awaitConfirmation) {
          commit('SET_IS_LOADING_TERMINAL_PAYMENT', false)
          commit('SET_IS_CREATING_INVOICE', false)
          commit('posCheckout/SET_IS_LOADING_PAYMENT', false, { root: true })
          dispatch('posTerminal/resetStatusDialog', null, { root: true })
        }

        return { data }
      })
  },
  registerInvoicePayment ({ commit, state }, { invoice, paymentMethod, account, date, amount }) {
    commit('SET_IS_LOADING_REGISTER_PAYMENT', true)
    return InvoiceService.registerInvoicePayment({ invoiceId: invoice.id, paymentMethodId: paymentMethod.id, accountId: account.id, date, amount })
      .then(({ data }) => {
        if (data.status === 'success') {
          // skriv över invoice, kontrollerar först att inte ny invoice har öppnats i dialogen
          if (data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
            commit('TRIGGER_CUSTOMER_CREDIT_UPDATED')
          }
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_REGISTER_PAYMENT', false)
      })
  },
  createCreditInvoice ({ commit, state }, { creditSalesItems, originalInvoiceId }) {
    // Skapa kreditfaktura och applicera kredit direkt på en faktura - inte till för att skapa kreditfaktura från kassan
    commit('SET_IS_LOADING_REGISTER_CREDIT_INVOICE_IDS', { originalInvoiceId, val: true })
    return InvoiceService.createCreditInvoice({ creditSalesItems, originalInvoiceId })
      .then(({ data }) => {
        if (data.status === 'success') {
          // skriv över invoice, kontrollerar först att inte ny invoice har öppnats i dialogen
          if (data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
          }
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_REGISTER_CREDIT_INVOICE_IDS', { originalInvoiceId, val: false })
      })
  },
  reverseInvoicePayment ({ commit, state }, { paymentId, invoiceId }) {
    commit('SET_IS_LOADING_REVERSE_PAYMENT_IDS', { paymentId, val: true })
    return InvoiceService.reversePayment({ paymentId, invoiceId })
      .then(({ data }) => {
        if (data.status === 'success') {
          // skriv över invoice, kontrollerar först att inte ny invoice har öppnats i dialogen
          if (data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
          }
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_REVERSE_PAYMENT_IDS', { paymentId, val: false })
        commit('TRIGGER_PAYMENT_UPDATED')
        commit('TRIGGER_CUSTOMER_CREDIT_UPDATED')
      })
  },
  reversePayment ({ commit, state }, paymentId) {
    commit('SET_IS_LOADING_REVERSE_PAYMENT_IDS', { paymentId, val: true })
    return InvoiceService.reversePayment({ paymentId })
      .then(({ data }) => {
        if (data.status === 'success') {
          // TODO:
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_REVERSE_PAYMENT_IDS', { paymentId, val: false })
        commit('TRIGGER_PAYMENT_UPDATED')
      })
  },
  reverseInvoicePaymentApplication ({ commit, state }, paymentApplicationId) {
    commit('SET_IS_LOADING_REVERSE_PAYMENT_APPLICATION_IDS', { paymentApplicationId, val: true })
    return InvoiceService.reverseInvoicePaymentApplication({ paymentApplicationId })
      .then(({ data }) => {
        if (data.status === 'success') {
          // skriv över invoice, kontrollerar först att inte ny invoice har öppnats i dialogen
          if (data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
          }
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_REVERSE_PAYMENT_APPLICATION_IDS', { paymentApplicationId, val: false })
        commit('TRIGGER_PAYMENT_APPLICATION_UPDATED')
        commit('TRIGGER_CUSTOMER_CREDIT_UPDATED')
      })
  },
  initPayment ({ state, rootState, commit, dispatch }, { invoice, paymentMethod, amount, customerCreditAmount }) {
    commit('posTerminal/SET_TERMINAL_CANCELLING', false, { root: true })
    commit('SET_IS_LOADING_PAYMENT', true)
    if (paymentMethod && paymentMethod.gateway === 'integrated_terminal') {
      dispatch('posTerminal/resetStatusDialog', null, { root: true })
      commit('SET_IS_LOADING_TERMINAL_PAYMENT', true)
    }
    let paymentMethodId
    if (paymentMethod === null) {
      paymentMethodId = null
    } else {
      paymentMethodId = paymentMethod.id
    }
    const invoiceId = invoice.id
    const workstationId = rootState.workstation.id
    return InvoiceService.checkout({ invoiceId, paymentMethodId, workstationId, amount, customerCreditAmount })
      .then(({ data }) => {
        if (data.status === 'success' && data.data.transaction_status === 'confirmed') {
          console.log('confirmed')
          // skriv över invoice, kontrollerar först att inte ny invoice har öppnats i dialogen
          if (data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
            commit('TRIGGER_CUSTOMER_CREDIT_UPDATED')
          }
          commit('SET_IS_LOADING_TERMINAL_PAYMENT', false)
          commit('SET_IS_LOADING_PAYMENT', false)
        } else if (data.status === 'success' && data.data.transaction_status === 'await_confirmation') {
          console.log('await_confirmation')
          // Om transaction_status är await_confirmation uppdateras det när pusher kommer eller efter timeout
          dispatch('posTerminal/startTerminalTimeout', {
            timeout: data.data.terminal_timeout,
            isInvoicePayment: true
          }, { root: true })
        } else if (data.status === 'error') {
          console.log('error', data)
          commit('SET_IS_LOADING_PAYMENT', false)
          commit('SET_IS_LOADING_TERMINAL_PAYMENT', false)
        }
      })
  },
  refundInvoicePayment ({ commit, state }, { paymentId, invoiceId }) {
    commit('SET_IS_LOADING_REFUND_PAYMENT_IDS', { paymentId, val: true })
    return InvoiceService.refundPayment({ paymentId, invoiceId })
      .then(({ data }) => {
        if (data.status === 'success') {
          if (data.data.invoice && data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
          }
        }
      })
      .finally(() => {
        commit('SET_IS_LOADING_REFUND_PAYMENT_IDS', { paymentId, val: false })
        commit('TRIGGER_PAYMENT_UPDATED')
        commit('TRIGGER_CUSTOMER_CREDIT_UPDATED')
      })
  },
  resendInvoice ({ state, commit }, { invoiceId, withPaymentLink = false }) {
    commit('SET_IS_SENDING_INVOICE_IDS', { invoiceId, val: true })
    return InvoiceService.resendInvoice({ invoiceId, withPaymentLink })
      .then(({ data }) => {
        if (data.status === 'success' && state.dialog.invoice.id === invoiceId) {
          commit('SET_IS_AWAITING_EMAIL_SAVED_INVOICE_ID', { invoiceId, val: true })
        }
      })
      .finally(() => {
        commit('SET_IS_SENDING_INVOICE_IDS', { invoiceId, val: false })
      })
  },
  sendInvoiceReminder ({ state, commit }, { invoiceId }) {
    commit('SET_IS_SENDING_REMINDER_INVOICE_IDS', { invoiceId, val: true })
    return InvoiceService.sendInvoiceReminder({ invoiceId })
      .then(({ data }) => {
        // snackbar bekräftelse från servern
        if (data.status === 'success' && state.dialog.invoice.id === invoiceId) {
          // fakturan är öppen i dialogen
          commit('SET_IS_AWAITING_EMAIL_SAVED_INVOICE_ID', { invoiceId, val: true })
        }
      })
      .finally(() => {
        commit('SET_IS_SENDING_REMINDER_INVOICE_IDS', { invoiceId, val: false })
      })
  },
  sendPaymentConfirmation ({ state, commit }, { paymentId, invoiceId }) {
    commit('SET_IS_SENDING_CONFIRMATION_PAYMENT_IDS', { paymentId, val: true })
    return InvoiceService.sendPaymentConfirmation({ paymentId })
      .then(({ data }) => {
        // snackbar bekräftelse från servern
        if (data.status === 'success' && state.dialog.invoice.id === invoiceId) {
          // fakturan är öppen i dialogen
          commit('SET_IS_AWAITING_EMAIL_SAVED_PAYMENT_ID', { paymentId, val: true })
        }
      })
      .finally(() => {
        commit('SET_IS_SENDING_CONFIRMATION_PAYMENT_IDS', { paymentId, val: false })
      })
  },
  convertToCredit ({ commit }, { invoiceId }) {
    commit('SET_IS_LOADING_CONVERT_TO_CREDIT', true)
    return InvoiceService.convertToCredit({ invoiceId })
      .then(({ data }) => {
        if (data.status === 'success') {
          // skriv över invoice, kontrollerar först att inte ny invoice har öppnats i dialogen
          if (data.data.invoice.id === state.dialog.invoice.id) {
            window.enrich.enrichInvoice(data.data.invoice)
            commit('SET_DIALOG_INVOICE', data.data.invoice)
            commit('TRIGGER_INVOICE_UPDATED')
          }
        }
      })
      .finally(() => {
        commit('TRIGGER_PAYMENT_APPLICATION_UPDATED')
        commit('TRIGGER_CUSTOMER_CREDIT_UPDATED')
        commit('SET_IS_LOADING_CONVERT_TO_CREDIT', false)
      })
  },
  getDraftStatus ({ state, commit, dispatch }, invoiceDraftId) {
    return InvoiceService.getDraftStatus(invoiceDraftId)
      .then(({ data }) => {
        const draftStatus = data.data.draft_status
        if (draftStatus === 'completed') {
          const customerId = data.data.customer_id
          const bookingId = data.data.booking_id
          if (router.history.current.name === 'PosRegister') {
            // resettar varukorgen och kunden i kassan om fakturerat från kassan
            dispatch('posCart/reset', null, { root: true })
            commit('posRegister/SET_CUSTOMER', null, { root: true })
          }
          // öppnar customer eller booking dialog med faktura-tabben öppen
          if (state.shouldCheckOut) {
            router.push({ name: 'ActionsItems' })
          } else if (bookingId) {
            dispatch('booking/openDialogById', { bookingId, startTab: 'invoices' }, { root: true })
          } else {
            dispatch('customer/openDialogById', { customerId, startTab: 'invoices' }, { root: true })
          }
        } else {
          commit('SET_IS_LOADING_TERMINAL_PAYMENT', false)
          commit('SET_IS_CREATING_INVOICE', false)
          commit('posCheckout/SET_IS_LOADING_PAYMENT', false, { root: true })
          dispatch('posTerminal/resetStatusDialog', null, { root: true })
        }
      }
      )
  }
}

export const getters = {
  activePaymentTerms: function (state) {
    if (state.paymentTerms.length === 0) {
      return []
    }
    const activePaymentTerms = state.paymentTerms.filter(paymentTerm => {
      return paymentTerm.deleted_at === null
    })
    return activePaymentTerms
  }
}
